import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2ba1e0a1&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2ba1e0a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1e0a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba1e0a1')) {
      api.createRecord('2ba1e0a1', component.options)
    } else {
      api.reload('2ba1e0a1', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2ba1e0a1&scoped=true", function () {
      api.rerender('2ba1e0a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/buyer/detail.vue"
export default component.exports